import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Message, Button, Form } from 'semantic-ui-react'
const { Field } = Form
const log = require('debug')('app:components:AddAnswer')

const ConfirmDevice = class ConfirmDevice extends Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      isLoading: false,
      isSuccess: false,
      hasError: false,
      error: null,
      form: {
        code: '',
        list: false
      }
    }
  }
  onChange (e) {
    const updatedState = Object.assign({}, this.state.form, {
      [e.target.name]: e.target.value
    })
    this.setState({form: updatedState})
  }
  onDropdownChange (e, {value}) {
    const updatedState = Object.assign({}, this.state.form, {
      list: value
    })
    this.setState({form: updatedState})
  }
  handleSubmit (e) {
    const {handleConfirmation} = this.props
    const form = this.state.form
    e.preventDefault()

    this.setState({
      isLoading: true
    })

    handleConfirmation(form)
      .then((data) => {
        log(data)
        this.setState({
          isLoading: false,
          isSuccess: true,
          hasError: false,
          error: undefined,
          form: {
            code: ''
          }
        })
      })
      .catch(error => {
        console.log(error.meta.error.payload.message)
        this.setState({
          isLoading: false,
          hasError: true,
          error: {message: error.meta.error.payload.message},
          form: {}
        })
        log(error)
      })
  }
  render () {
    const {isSuccess, hasError, error, form} = this.state
    let errorNode

    if (hasError) {
      errorNode = <Message negative>{error.message}</Message>
    }
    var drowpdownOptions = [
      {
        key: 'Allow',
        text: 'Report and view',
        value: true
      },
      {
        key: 'Restrict',
        text: 'Only report',
        value: false
      }
    ]
    return (
      <Form loading={this.state.isLoading} type='inline' onSubmit={this.handleSubmit.bind(this)} success={isSuccess}>
        <h3>Confirm device</h3>
        <Message success>
          <Message.Header>Code added. The device should appear any moment.</Message.Header>
        </Message>
        {errorNode}
        <Form.Group inline>
          <Field inline>
            <label className='hide' htmlFor='answer'>Device code</label>
            <input style={{marginRight: '20px'}} value={form.code} placeholder='Enter device code' name='code' onChange={this.onChange.bind(this)} />
            <label className='hide' htmlFor='answer'>App permissions</label>
          </Field>
          <Field inline>
            <Form.Select value={this.state.form.list} options={drowpdownOptions} onChange={this.onDropdownChange.bind(this
            )} />
          </Field>
          <Field>
            <Button disabled={!form.code} type='submit'>Confirm</Button>
          </Field>
        </Form.Group>
      </Form>
    )
  }
}

ConfirmDevice.propTypes = {
  handleSubmit: PropTypes.func
}

export default ConfirmDevice



// WEBPACK FOOTER //
// ./src/components/ConfirmDevice/index.js